var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{style:({ width: '80vw', height: '100vh' }),attrs:{"closeable":"","position":"left"},model:{value:(_vm.popupShow),callback:function ($$v) {_vm.popupShow=$$v},expression:"popupShow"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }